<template lang="jade">
  .container-fluid
    .row
      .setting_main.col-md-12(v-if="!loadingData")
        header.setting_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12
            | settings
            span.deviceTime.col-md-3.pull-right.no_pad(v-if="$route.name === 'power'")
              |{{deviceTime}}
        section.information_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar information
          .id_group.col-lg-8.col-md-10.col-sm-12.col-xs-12.col-centered.clearfix
            template(v-for="(key,data) in device")
              //- span key is {{key}}
              //- br
              //- span data is {{data}}
              //- br
              .id__single.col-lg-6.col-md-6.col-sm-12.col-xs-12.clearfix(v-if="key !== 'description'")
                .id_key.col-lg-6.col-md-6.col-sm-4.col-xs-6.clearfix
                  span.key {{ namesToShow[key] }}
                .id_value.col-lg-6.col-md-6.col-sm-8.col-xs-6.clearfix(v-if="key === 'typeId'")
                  span.value {{ isSwitcher ? 'Switch' : types[data] }}
                .id_value.col-lg-6.col-md-6.col-sm-8.col-xs-6.clearfix(v-else)
                  span.value {{ data }}
              // (xs) Click on this to toggle display
              .id__single.col-md-12.col-sm-12(v-else)
                a(href="javascript:void(0);")
                  .id_key.col-md-3.col-sm-4.col-xs-6.description
                    span.key {{ namesToShow[key] }}
                  .id_value.col-lg-6.col-md-6.col-sm-8.col-xs-6.description_value
                      span.value {{ data }}
        section.identification_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar identification
          .device_name.col-lg-10.col-md-10.col-sm-12.col-xs-12.clearfix.no_pad-xs
            .col-xs-12
              label Device Name:
            .col-xs-8.col-sm-4.col-lg-3
              span
                validator(name='deviceNameValidator')
                  input.input.form-control(v-model='newNickname' maxlength='12' v-validate:devicename="['deviceValid']")
                span.error(v-show='$deviceNameValidator.devicename.invalid && $deviceNameValidator.devicename.modified')
                  |Only English characters, numbers ,'-' and '_' allowed
            .apply.col-xs-4.col-sm-4.col-lg-3
              button.btn.btn-success(v-on:click="chgName") apply
        section.time_zone_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs(v-if="$route.name === 'power' || $route.name === 'dio'")
          h2.title_bar Time
          .col-xs-12
            label Device Time:
          .col-sm-12.col-md-12.clearfix.no_pad-xs
            .col-xs-12.col-md-12clearfix.title
              span UTC
            .col-xs-12.col-md-12.clearfix.time
              span {{utcTime}}
            .col-xs-12.col-md-12.clearfix.title
              span {{timezone.id}}
            .col-xs-12.col-md-12.clearfix.time
              span {{deviceTime}}
          .col-xs-12
            label Device Time Zone:
          .col-sm-12.col-md-10.clearfix.no_pad-xs
            //- hide this, use normal select to show all the options
            //- .selector.col-xs-12
            //-   v-select(v-bind:options='timezoneUIOptions' v-bind:value.sync='timezoneIndex')
            .selector.col-xs-12
              select.form-control(v-model='timezoneIndex')
                option(v-for='opt in timezoneUIOptions' v-bind:value='opt.value' v-bind:selected.once="opt.value === timezoneIndex") {{opt.label}}
            .apply.col-xs-12
              button.btn.btn-success(v-on:click='applyTimeZone') Apply
        section.network_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar network
          .dhcp_config.col-lg-7.col-md-7.col-sm-12.col-xs-12.row_space--xxs.no_pad-xs
            validator(name='dhcpValidation')
              .col-lg-4.col-md-4.col-sm-12.col-xs-12
                span IP Address
                input.form-control(v-model="editting.deviceIpAddress" maxlength='15' v-validate:ip="['ipAddress']" disabled='true')
                span.error(v-show='$dhcpValidation.ip.invalid && $dhcpValidation.ip.modified')
                  | Please enter valid ip address
              .col-lg-4.col-md-4.col-sm-12.col-xs-12
                span Netmask
                input.form-control(v-model="editting.deviceSubnetMask" maxlength='15' v-validate:netmask="['ipAddress']" disabled='true')
                span.error(v-show='$dhcpValidation.netmask.invalid && $dhcpValidation.netmask.modified')
                  | Please enter valid netmask
              .col-lg-4.col-md-4.col-sm-12.col-xs-12
                span Gateway
                input.form-control(v-model="editting.deviceDefaultGateway" maxlength='15' v-validate:gateway="['ipAddress']" disabled='true')
                span.error(v-show='$dhcpValidation.gateway.invalid && $dhcpValidation.gateway.modified')
                  | Please enter valid gateway
        section.maintenance_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar maintenance
          .btn_group.col-lg-12.col-md-12.col-sm-8.col-xs-12.col-centered
            //- button.btn.btn-primary.clearfix.col-lg-2.col-lg-offset-0.col-md-10.col-md-offset-1.col-sm-8.col-sm-offset-2.col-xs-12(
              v-on:click="handleMaintenance"
              v-show="capability.system.upgrade")
              i.fa.fa-cloud-upload
              | update firmware
            //- button.btn.btn-danger.clearfix.col-lg-2.col-lg-offset-0.col-md-10.col-md-offset-1.col-sm-8.col-sm-offset-2.col-xs-12(
              v-on:click="resetToFactoryDefault"
              v-show="capability.system.default && isInstaller")
              i.fa.fa-gear
              | factory default
            button.btn.btn-danger.clearfix.col-lg-2.col-lg-offset-0.col-md-3.col-md-offset-0.col-sm-8.col-sm-offset-2.col-xs-12(
              v-on:click="reboot"
              v-show="capability.system.reboot")
              i.fa.fa-rotate-left
              | reboot
            //- button.btn.rollback.clearfix.col-lg-2.col-lg-offset-0.col-md-10.col-md-offset-1.col-sm-8.col-sm-offset-2.col-xs-12(
              v-on:click="rollbackFirmware"
              v-show="capability.system.rollback")
              i.fa.fa-level-down
              | RollBack
          modal.confirm_modal(
          title="Confirm"
          v-bind:show.sync= "showConfirm"
          effect= "zoom"
          v-bind:callback='confirmCb'
          ok-text="Yes"
          cancel-text="Cancel")
            .modal-body(slot='modal-body').clearfix {{ confirmMsg }}

</template>
<script>
import { getSpecificDevice, changeDeviceNickname, hasNewFirmware, call } from 'src/Service'
import { modal } from 'vue-strap'
import singleSelect from 'src/components/Single-Select.vue'
import _ from 'lodash'
import moment from 'moment'
const DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'

export default {
  components: {
    modal,
    'v-select': singleSelect
  },
  data: () => {
    return {
      loadingData: true,
      device: {},
      keyToDisable: [
        'type',
        'id',
        'ownerId',
        'installerId',
        'created_at',
        'installer_email',
        'mfg',
        'updated_at',
        'platform',
        'online',
        'serviceTag',
        'name',
        'model',
        'activeLog',
        'firmware_version'
      ],
      editting: {},
      newNickname: '',
      types: [
        '',  // reserve for type 0
        'DPS',
        'Matrix',
        'Mixer',
        'Video wall',
        'MES',
        'DIO'
      ],
      namesToShow: {
        mac_address: 'Mac Address',
        typeId: 'Device Type',
        serialNum: 'Serial No.',
        ip_address: 'Device IP',
        firmware: 'Firmware',
        nickname: 'Device Name',
        description: 'Model Description'
      },
      showConfirm: false,
      confirmMsg: '',
      confirmCb: function () {},
      capability: {},
      timezoneOptions: [],
      timezoneUIOptions: [],
      timezone: {},
      timezoneIndex: '',
      timezoneKeyAry: [],
      currentTime: '',
      isSwitcher: false
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    let deviceRet = {}
    if (this.$route.name === 'power' || this.$route.name === 'dio') { // setting of power needs to load timezone
      return getSpecificDevice(mac).then((device) => {
        console.log(device)
        this.newNickname = device.nickname
        for (let key in device) {
          if (this.keyToDisable.indexOf(key) === -1) {
            deviceRet[key] = device[key]
          }
        }
        return call(mac, 'dxGetNetworkSettings')
      }).then(settings => {
        this.loadingData = false
        this.editting = settings
        // needs to show ip in device information
        deviceRet.ip_address = this.editting.deviceIpAddress
        return call(mac, 'dxGetTimeZone')
      }).then(({timezone}) => {
        this.timezone = timezone
        return call(mac, 'dxGetTimeZoneOptions')
      }).then(({options}) => {
        let opts = []
        let keyAry = []
        // trun timezone and timezoneOptions to proper data structure
        for (let i = 0; i < options.length; i++) {
          opts.push({
            label: options[i].id,
            value: i
          })

          keyAry.push(i)

          if (options[i].id === this.timezone.id) {
            this.timezoneIndex = i
          }
        }
        this.timezoneKeyAry = keyAry
        this.timezoneUIOptions = opts
        this.timezoneOptions = options
        return call(mac, 'dxGetAbout')
      }).then(({firmware, description, capability, model}) => {
        // gomax 有一批貨是 model 跟 description 寫相反
        // 這段只針對這批貨做修改，其他不動 by Walter 20190315
        // "model": "8x8 HDMI 2.0a Matrix",
        // "description": "MA-5588H2",
        if (model === '8x8 HDMI 2.0a Matrix' && description === 'MA-5588H2') {
          deviceRet.description = '8x8 HDMI 2.0a Matrix'
        } else {
          deviceRet.description = description
        }
        deviceRet.firmware = firmware
        return {
          device: deviceRet,
          capability
        }
      }).catch((err) => {
        console.error(err)
        setTimeout(this.reloadAsyncData, 1000)
      })
    } else { // else device
      return getSpecificDevice(mac).then((device) => {
        console.log('device is ===>', device)
        this.newNickname = device.nickname
        for (let key in device) {
          if (this.keyToDisable.indexOf(key) === -1) {
            deviceRet[key] = device[key]
          }

          if (key === 'model' && device[key].includes('SW')) {
            this.isSwitcher = device[key].includes('SW')
            this.$dispatch('updateIsSwitcher', this.isSwitcher)
          }
        }
        return call(mac, 'dxGetNetworkSettings')
      }).then(settings => {
        this.loadingData = false
        this.editting = settings
        // needs to show ip in device information
        deviceRet.ip_address = this.editting.deviceIpAddress
        return call(mac, 'dxGetAbout')
      }).then(({firmware, description, capability}) => {
        // Change the description only for the 8x8 Matrix tempararily by Walter 20180118
        console.log('description', description)
        if (description) {
          if (description.indexOf('MA-5588H2') !== -1) {
            deviceRet.description = '8x8 HDMI 2.0a Matrix'
          } else {
            deviceRet.description = description
          }
        }
        deviceRet.firmware = firmware
        return {
          device: deviceRet,
          capability
        }
      }).catch((err) => {
        console.error(err)
        setTimeout(this.reloadAsyncData, 1000)
      })
    }
  },
  computed: {
    utcTime () {
      return moment(this.currentTime).utc().format(DEVICE_TIME_FORMAT)
    },
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT)
      }
    },
    isDST () {
      return moment().isDST()
    }
  },
  ready () {
    this.updateTime()
  },
  events: {
    user (uid, user) {
      this.isInstaller = user.installer
    }
  },
  methods: {
    applyTimeZone () {
      call(this.$route.params.mac, 'dxSetTimeZone', {
        timezone: this.timezoneOptions[this.timezoneIndex]
      }).then(res => {
        // Because the event dsStatusNotification sends is an timezone object, so
        // directly changed the UI data so dont need to parse the data into index again
        // In other pages of power, need to update the timezone by event.
        this.timezone = this.timezoneOptions[this.timezoneIndex]
      }).catch(err => {
        console.log(err)
      })
    },
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    chgName () {
      let newDevice = _.clone(this.device)
      if (this.$deviceNameValidator.devicename.valid && this.newNickname) {
        changeDeviceNickname(this.$route.params.mac, this.newNickname.trim()).then(() => {
          newDevice.nickname = this.newNickname
          this.device = newDevice
          // Vue detect the parent object only ,
          // so "this.device.nickname = this.newNickname" won't trigger the view update
          this.alert('success', '', `Device Name has been set to '${this.newNickname}'.`)
        })
      } else {
        this.alert('danger', '', 'Please enter at least one English character or number only.')
      }
    },
    handleConfirmModal (msg, callback) {
      let confirmCb = () => {
        callback()
        this.showConfirm = false
      }
      this.confirmMsg = msg
      this.confirmCb = confirmCb
      this.showConfirm = true
    },
    handleMaintenance () {
      hasNewFirmware({
        mac: this.$route.params.mac,
        version: this.device.firmware_version
      })
      .then(newV => {
        if (newV) {
          this.handleConfirmModal(`Your device is on firmware ${this.device.firmware_version} Do you want to update to ${newV}?`, () => {
            call(this.$route.params.mac, 'dxUpdateFirmware', {url: newV})
          })
        } else {
          this.handleConfirmModal('Your device firmware is the lastest .')
        }
      })
    },
    rollbackFirmware () {
      this.handleConfirmModal('Are you sure you want to rollback?', () => {
        call(this.$route.params.mac, 'dxRollbackDevice', {})
      })
    },
    resetToFactoryDefault () {
      this.handleConfirmModal('Do you want to reset the device to factory default?', () => {
        call(this.$route.params.mac, 'dxDefaultDevice', {})
        .then((resolved) => {
          console.log('resolved: ', resolved)
        }, (rejected) => {
          console.log('in rejected')
          this.alert('danger', 'Error resetting to factory default', rejected)
        })
      })
    },
    reboot () {
      this.handleConfirmModal('Do you want to reboot the device?', () => {
        call(this.$route.params.mac, 'dxResetDevice', {})
        .then((resolved) => {
          console.log(resolved)
        }, (rejected) => {
          this.alert('danger', 'Error in reboot', rejected)
        })
      })
    },
    setNetwork () {
      console.log('set network')
      let obj = {}
      if ((obj.dhcpEnabled = this.editting.dhcpEnabled) === false) {
        if (this.$dhcpValidation.ip.valid && this.$dhcpValidation.netmask.valid && this.$dhcpValidation.gateway.valid) {
          obj.dhcpEnabled = false
          obj.deviceIpAddress = this.editting.deviceIpAddress
          obj.deviceSubnetMask = this.editting.deviceSubnetMask
          obj.deviceDefaultGateway = this.editting.deviceDefaultGateway
        } else {
          this.alert('danger', '', 'Please enter valid ip or valid netmask or valid gateway.')
          return
        }
      }

      call(this.$route.params.mac, 'dxSetNetworkSettings', obj)
      .then((resolved) => {
        if (resolved.error && resolved.error.msg) {
          this.alert('danger', '', resolved.error.msg)
        } else {
          console.log(resolved)
          // this.alert('success', '', 'network setting success')
        }
      }, (rejected) => {
        if (rejected.error || rejected.error.msg) {
          this.alert('danger', '', rejected.error || rejected.error.msg)
        }
      })
    }
  } // close methods
}
</script>

<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  section,header{
    border-bottom: 1px solid $GLOBAL_border;
    &:last-child{
      border:none;
    }
  }
  .information_section{
    font-size: 20px;
    .id_group{
      border:1px solid $pri_gray;
      padding:0;
      border-radius:$base_border_radius;
      background: #e5e5e5;
    }
    .id__single{
      padding-left:0;
      padding-right: 0;


      .id_key, .id_value{
        min-height:40px;
      }

      .id_key{
        padding: 0;

        span{
          display: inline-block;
          width: 100%;
          padding-left:5%;
          background-color: $BS_table_header_bg;
          @include breakpoint(xxs){
            text-align: center;
          }
        }
      }
      & .id_value{
        padding: 0px 7px;
        text-align: center;
      }

      & a {
        color: $GLOBAL_fg;
        display:inline-block;
        text-decoration: none;
        width: 100%;
        cursor: default;
        @include breakpoint(xs){
          cursor: pointer;
          & span{
            overflow: scroll;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          &:focus{
            .id_value{
              width:100%;
            }
            .id_key{
              width: 100%;
            }
          }
        }
      }
      // .id_value{
      //   &.description_value{
      //     /* padding: 0; */
      //     & a {
      //       display: inline-block;
      //       text-decoration: none;
      //       width: 100%;
      //       &:focus{
      //         white-space: initial;
      //         text-overflow: initial;
      //       }
      //     }
      //   }
      // }
      span{
        margin: 0;
      }
      span.key{
        text-transform:capitalize;
        height: 100%;
        line-height:40px;
      }
      span.value{
        display: inline-block;
        width: 100%;
        height: 100%;
        color:$base_gray;
        line-height:40px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }


  /* ==== information section ==== */
  .identification_section{
    font-size: 22px;

    .btn{
      color:$base_white;
      text-transform:capitalize;
    }

    .device_name{
      & label{
        font-size: 14px;
        white-space:nowrap;
        font-weight: 500;
        display:block;
      }
      & > span {
        vertical-align:middle;
        display:inline-block;
        width: 35%;
        margin-right: 20px;
      }
    }

    .apply{
      text-align: center;
    }
  }
  /* ==== network section ==== */
  .dhcp_config{
    > div {
      margin-bottom: 10px;
    }
    font-size: 14px;
  }
  .network_section{
    .dhcp span{
      font-size: 16px;
      text-transform:uppercase;
    }
    .dhcp label{
      cursor:pointer;
    }
  }
  .iosCheck input {
    display: none;
  }
  .iosCheck i {
    display: inline-block;
    cursor: pointer;
    padding-right: 25px;
    transition: all ease 0.2s;
    -webkit-transition: all ease 0.2s;
    border-radius: 25px;
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
  }
  .iosCheck i:before {
    display: block;
    content: '';
    width: 25px;
    height: 25px;
    border-radius: 25px;
    background: white;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }
  .iosCheck :checked + i {
    padding-right: 0;
    padding-left: 25px;
    background: #00e970;
    box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 40px #00e079;
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5), inset 0 0 40px #00e079;
  }



  /* ==== maintenance section ==== */
  .maintenance_section{
    & .btn_group{
      & .btn{
        float: left;
        margin-right: 15px;
        margin-top: 15px;
        padding:10px 20px;
        text-transform:capitalize;
        font-size: 16px;
      }
      & i.fa{
        margin-right: 5px;
      }
    }

  }


    /* ============ responsive ===========*/
    /* xs */
    @include breakpoint(xs) {
      .identification_section {
        .device_name{
          & label{
            margin-bottom: 20px;
          }
          & > span {
            display:block;
            width: 100%;
            margin-bottom: 20px;
          }
          & > .btn {
            width: 100%;
          }
        }
      }
    }
    /* xxs */
    @include breakpoint(xxs) {
      .id_group{
        font-size: 13px;
      }
    }
  .time_zone_section{
    & label{
      font-size: 14px;
    }
    & .title{
      margin-bottom: 5px;

      @include breakpoint(xs) {
        text-align: left;
      }

      & span{
        background-color: #777;
        color: #fff;
        display: inline-block;
        padding: 1px 4px;
        border-radius: 3px;
        white-space: nowrap;
      }

      &:nth-child(3) span {
        @include breakpoint (xs) {
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }

    & .time{
      margin-bottom: 5px;
      & span {
        font-family: monospace;
      }
      height: 24px;
    }

    & .apply , & .selector {
      @include breakpoint(xs) {
        width: auto;
      }

      @include breakpoint(md) {
        width: auto;
      }

      @include breakpoint(lg) {
        width: auto;
      }
    }

    & .selector {
      margin-bottom: 7px;
      position: relative;

      // @include breakpoint(xxs) {
      //   &:after {
      //     content: '';
      //     display: block;
      //     position: absolute;
      //     right: 25px;
      //     top: 15px;
      //     border: 5px solid transparent;
      //     border-top-color: #000;
      //   }
      // }
    }
  }

</style>



// WEBPACK FOOTER //
// Setting.vue?904c7ee8